/**
 * Detects the scrollbar width in pixels.
 * Creates a temporary scrollable element to measure the difference between
 * offsetWidth (includes scrollbar) and clientWidth (excludes scrollbar).
 * Returns 0 for overlay scrollbars (macOS default) or the actual width (typically 15-17px on Windows/Linux).
 */
export function getScrollbarWidth() {
  if (typeof document === 'undefined') return 0

  const div = document.createElement('div')
  div.style.width = '100px'
  div.style.height = '100px'
  div.style.overflow = 'scroll'
  div.style.position = 'absolute'
  div.style.top = '-9999px'

  document.body.appendChild(div)
  const scrollbarWidth = div.offsetWidth - div.clientWidth
  document.body.removeChild(div)

  return scrollbarWidth
}
